// Número oficial do WhatsApp Business (bot de atendimento) — fonte única da verdade.
// Confirmado via Graph API: display_phone_number "+55 11 5143-0600".
// Formato wa.me: somente dígitos, com DDI (55) + DDD (11) + número, sem espaços/sinais.
export const WHATSAPP_NUMBER = '551151430600';

// Exibição amigável (para textos visíveis na UI).
export const WHATSAPP_DISPLAY = '+55 (11) 5143-0600';

// Mensagem padrão pré-preenchida ao abrir a conversa (já reabre a janela de 24h do bot).
export const WHATSAPP_DEFAULT_MESSAGE = 'Olá! Vim pelo site e gostaria de saber mais.';

/**
 * Monta o link wa.me para o número do bot, opcionalmente com mensagem pré-preenchida.
 * @param message texto inicial; passe '' para abrir o chat vazio.
 */
export function whatsappLink(message: string = WHATSAPP_DEFAULT_MESSAGE): string {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
